import styled from '@emotion/native';
import React, { FC } from 'react';
import { StyleSheet, Dimensions } from 'react-native';
import AppIntroSlider from 'react-native-app-intro-slider';

import { Spacer, Text } from '@components/1-atoms';

const horizontalPadding = 15;
const viewportHeight = Dimensions.get('window').height - 120;

const styles = StyleSheet.create({
  dotStyle: {
    backgroundColor: 'rgba(0, 0, 0, .3)',
  },

  activeDotStyle: {
    borderColor: 'rgba(0, 0, 0, .9)',
    borderRadius: 15,
    borderWidth: 3,
    width: 15,
    height: 15,
    backgroundColor: 'rgba(255, 255, 255, .9)',
  },

  slider: {
    // backgroundColor: "pink",
    height: viewportHeight,
  },
});


const Header = styled.View``;

const Title = styled(Text)`
    color: #FFF;
    font-size: 48px;
    line-height: 53px;
`;

const Subtitle = styled(Text)`
    color: #FFF;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.5px;
`;

const Slide = styled.View`
    // background-color: yellow;

    align-items: center;
    // justify-content: center;

    padding-right: ${horizontalPadding}px;
    padding-left: ${horizontalPadding}px;

`;

const Preview = styled.View`
    // background-color: green;
    width: 100%;

    align-items: center;
    justify-content: flex-start;
`;

const Image = styled.ImageBackground``;

const Button = styled.View`
    background-color: rgba(0, 0, 0, .9);
    border-color: #0051c0;
    
    border-width: 3px;
    border-radius: 5px;

    justify-content: center;
    align-items: center;
`;

  const InnerButton = styled.View<{ innerBorder?: boolean;}>`
    width: 60px;
    height: 33px;

    ${props => `border-color: ${props.innerBorder ? "#FFF" : "transparent"};`}
    border-width: 1.3px;

    justify-content: center;
    align-items: center;
  `;

const ButtonText = styled.Text`
    color: #FFF;
    font-weight: 700;
`;


export type Slide = {
  title: string;
  subtitle?: string;
  image: any;
}

export type Props = {
  data: Array<Slide>;
  onSkip: () => void;
  onDone: () => void;
};


const Component: FC<Props> = ({ data, ...props }) => {

  // Render Functions
  const renderItem = ({ item, index, dimensions }: any) => {

    return (
      <Slide key={index}>
        <Header>
          <Spacer h={3} />
          <Title bold>{item.title}</Title>
          <Spacer h={1} />

          {item.subtitle ? <Subtitle>{item.subtitle}</Subtitle> : null}
        </Header>

        <Preview>
          <Image
            resizeMode="contain"
            source={item.image}
            style={{ width: dimensions.width - (horizontalPadding * 2), height: dimensions.height }}
          />
        </Preview>
      </Slide>
    );

  };


  const renderButton = (label: string, innerBorder = false) => (
    <Button>
      <InnerButton innerBorder={innerBorder}>
        <ButtonText>{label}</ButtonText>
      </InnerButton>
    </Button>
  );

  return (
    <AppIntroSlider
      data={data}
      renderItem={renderItem}

      showSkipButton
      showDoneButton
      showNextButton

      // Buttons
      renderSkipButton={() => renderButton('Skip')}
      renderDoneButton={() => renderButton('Done', true)}
      renderNextButton={() => renderButton('Next', true)}

      // Pagination Styles
      dotStyle={styles.dotStyle}
      activeDotStyle={styles.activeDotStyle}
      style={styles.slider}

      {...props}
    />
  );
};

export default Component;